import React from 'react';
import PropTypes from 'prop-types';
import style from './fullPageWidth.scss';
import classnames from 'classnames';

export function FullPageWidth(props) {
    const { className, innerClassName, hasBackground, hasPadding, dataTn, ...otherProps } = props;
    const classNames = classnames(style.container, className, {
        [style.background]: hasBackground,
    });
    const innerClassNames = classnames(innerClassName, style.padding);
    const content = hasPadding ? (
        <div className={innerClassNames}>{props.children}</div>
    ) : (
        props.children
    );

    return (
        <div className={classNames} {...otherProps} data-tn={dataTn}>
            {content}
        </div>
    );
}

FullPageWidth.propTypes = {
    className: PropTypes.string,
    innerClassName: PropTypes.string,
    hasBackground: PropTypes.bool,
    hasPadding: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.array,
        // object allows for passing in a single node
        PropTypes.object,
    ]).isRequired,
    dataTn: PropTypes.string,
};

FullPageWidth.defaultProps = {
    hasBackground: false,
    hasPadding: false,
};
